<template>
  <div>
    <CRUDDialog
    ref="crudDialog"
    onlyDialogHeaderName="Browse Last Payment"
    :baseCrudKey="baseCrudKey"
    :canSave="false"
    >
      <template v-slot:[`editedItem`]="{}">
        <CRUDList
        ref="crudList"
        tableDynamicHeight="200"
        tableWrapperDynamicClassname="taxroll-table-wrapper-two"
        :canAdd="false"
        :canEdit="false"
        :canSave="false"
        :showSelect="false"
        :showDialog="false"
        :displayTopPagination="false"
        :hideDefaultFooter="true"
        :headers="headers"
        :baseCrudKey="baseCrudKey"
        :defaultSortBy="defaultSortBy"
        @onSingleClicked="handleSingleOrArrowClick"
        @onArrowUpOrDown="handleSingleOrArrowClick"
        >
      </CRUDList>
      <v-btn text color="blue darken-1" class="input-text-size mt-5 ml-5" @click="addToList">
          Add to Pick List
      </v-btn>
      <v-btn text color="blue darken-1" class="input-text-size mt-5 ml-5" @click="addAllToList">
          Add All to Pick List
      </v-btn>
    </template>
  </CRUDDialog>
</div>
</template>

<script>
import {
  mapActions,
  mapGetters,
} from 'vuex';
import CRUDList from '../../../common/base/crud-2.0/CRUDList.vue';
import CRUDDialog from '../../../common/base/crud-2.0/CRUDDialog.vue';
import { browsePaidByHeader } from '../TaxInquiryUtils/TableHeaders.utils';
import { getWorkstationNumber } from '../../../../util/workstation-util';

export default {
  name: 'BrowsePaidBy',
  components: {
    CRUDDialog,
    CRUDList,
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'browsePaidBy',
    },
  },
  data() {
    return {
      headers: browsePaidByHeader,
      wkstNumber: getWorkstationNumber(),
      selectedRowData: {},
    };
  },
  computed: {
    ...mapGetters('base/crud', [
      'items',
    ]),
    defaultSortBy() {
      return [
        {
          column: 'taxYear',
          direction: 'desc',
        },
      ];
    },
  },
  methods: {
    ...mapActions('tax/taxInquiryTabs', [
      'UpsertBrowsePaidByPickListSingleNMultiplipleHybrid',
      'UpsertBrowsePaidByPickListSingleNMultiplipleUnpaidHybrid',
    ]),
    async handleSingleOrArrowClick(fromCrud) {
      this.selectedRowData = { ...fromCrud };
    },
    addAllToList() {
      const itemsData = this.items(this.baseCrudKey);
      if (itemsData.length > 0) {
        const itemList = itemsData.map((ft) => (ft.taxId));
        const item = {
          taxIds: itemList,
          workstation: Number(this.wkstNumber),
        };
        this.UpsertBrowsePaidByPickListSingleNMultiplipleUnpaidHybrid({ item });
      }
    },
    addToList() {
      const itemData = { ...this.selectedRowData };
      if (Object.keys(itemData).length > 0) {
        const item = {
          browseByPaidByList: [{ taxId: itemData.taxId, taxYear: itemData.taxYear }],
          workstation: Number(this.wkstNumber),
        };
        this.UpsertBrowsePaidByPickListSingleNMultiplipleHybrid({ item });
      }
    },
  },
};
</script>
